<template>
  <RevIllustration
    :src="photo.src"
    :width="box.width"
    :height="box.height"
    alt=""
    aria-hidden="true"
    loading="lazy"
    :class="box.aspect"
    class="rounded-md w-full object-cover"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RevIllustration } from '@ds/components/Illustration'

import type { MetalPhoto } from '~/scopes/campaign/data/metals/types'

// The one box in the campaign that crops: a bento needs a shared ratio per cell, where
// `ImageFigure` renders article photography as shot.
const props = defineProps<{ photo: MetalPhoto }>()

// `width`/`height` only reserve space, so they carry the cell's ratio, not the file's.
const BOXES = {
  horizontal: { width: 1600, height: 900, aspect: 'aspect-video' },
  vertical: { width: 800, height: 1000, aspect: 'aspect-[4/5]' },
} as const

const box = computed(() => BOXES[props.photo.orientation])
</script>
